import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../services/seo.service';
import { TableScrollTop } from '../../directives/table-scroll-top';

@Component({
  selector: 'app-mari-privacy-notice',
  imports: [RouterLink, TableScrollTop],
  templateUrl: './mari-privacy-notice.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mari-privacy-notice.scss',
})
export class MariPrivacyNotice {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – MARI Privacy Notice';
  protected readonly seoDescription =
    'Read the MARI Privacy Notice, covering the personal data MARI Group collects from website visitors, contractors, business partners, and others, and how it is used, shared, transferred, retained, and protected.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Privacy', path: '/privacy' },
        { name: 'MARI Privacy Notice', path: '/mari-privacy-notice' },
      ],
    });
  }
}
